/**
 * ElForm 验证的触发类型
 */
export enum FormTrigger {
    /**
     * 失去焦点
     */
    blur = 'blur',
    /**
     * 值改变
     */
    change = 'change'
}

/**
 * ElRule Type
 */
export enum ElRuleType {
    string = 'string',
    boolean = 'boolean',
    method = 'method',
    regexp = 'regexp',
    integer = 'integer',
    float = 'float',
    array = 'array',
    object = 'object',
    enum = 'enum',
    date = 'date',
    url = 'url',
    hex = 'hex',
    email = 'email',
    number = 'number',
}
const url = /^http:\/\/([\w-]+\.)+[\w-]+(\/[\w-.\/?%&=]*)?$/;

export const REGEXP = {
    整数: /^[-+]?\d*$/,
    双精度: /^[-\+]?\d+(\.\d+)?$/,
    汉字: /^[\u4e00-\u9fa5]{0,}$/,
    英文: /^[A-Za-z]+$/,
    大写英文: /^[A-Z]+$/,
    小写英文: /^[a-z]+$/,
    英文和数字: /^[A-Za-z0-9]+$/,
    中文英文数字: /^[\u4E00-\u9FA5A-Za-z0-9]+$/,
    英文或数字或下划线: /^\w+$/,
    中文英文下划线数字: /^[\u4E00-\u9FA5A-Za-z0-9_]+$/,
    Email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    域名: /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\/.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\/.?/,
    URL: url,
    手机号码: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
    // 电话号码: /^(\(\d{3,4}-)|\d{3.4}-)?\d{7,8}$/,
    国内电话号码: /\d{3}-\d{8}|\d{4}-\d{7}/,
    /** 15 或者 18 位 */
    身份证号: /^\d{15}|\d{18}$/,
    短身份证: /^([0-9]){7,18}(x|X)?$/,
    /** 必须包含大小写字母和数字的组合，不能使用特殊字符，长度在8-10之间 */
    强密码: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$/,
    日期格式: /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/,
    时间格式: /^((20|21|22|23|[0-1]\d)\:[0-5][0-9])(\:[0-5][0-9])?$/,
    日期时间格式: /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/,
    空白行: /\n\s*\r/,
    HTML标记: /<(\S*?)[^>]*>.*?<\/\1>|<.*? \/>/,
    /** 首行尾的空白字符(包括空格、制表符、换页符等等) */
    首尾空白字符: /^\s*|\s*$/,
    QQ号: /[1-9][0-9]{4,}/,
    邮编: /[1-9]\d{5}(?!\d)/,
    IP地址: /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/,
    里程桩号: /^[a-zA-Z]{0,3}?[Kk]\d{1,4}\+(\d{1,3})(\.\d{1,3})?$|^[a-zA-Z]?[Kk]\d{1,4}$/,
};

class ValidatorHelper {

    //#region 校验方法

    /**
     * validator
     */
    public validator(reg, obj): boolean {
        return reg.test(obj);
    }


    /**
     * 判断输入内容是否为空 
     * @param obj 
     */
    public isNull(obj) {
        if (obj === "" || obj === null || obj === undefined || obj === "undefined")
            return true;
        return false;
    }

    /**
     * 判断日期类型是否为YYYY-MM-DD格式的类型  
     * @param obj 
     */
    public isDate(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.日期格式, obj);
    }

    /**
     * 判断日期类型是否为YYYY-MM-DD hh:mm:ss格式的类型
     * @param obj 
     */
    public isDateTime(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.日期时间格式, obj);
    }

    /**
     * 判断日期类型是否为hh:mm:ss格式的类型
     * @param obj 
     */
    public isTime(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.时间格式, obj);
    }

    /**
     * 是否为英文字母
     * @param obj 
     */
    public isLetter(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.英文, obj);
    }

    /**
     * 判断是否为整数
     * @param obj 
     */
    public isInt(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.整数, obj);
    }


    /**
     * 判断是否为双精度
     * @param obj 
     */
    public isDouble(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.双精度, obj);
    }

    /**
     * 判断是否为字母和数字
     * @param obj 
     */
    public isLetterAndNumber(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.英文和数字, obj);
    }

    /**
     * 判断是否为汉字
     * @param obj 
     */
    public isChinese(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.汉字, obj);
    }

    /**
     * 判断是否为邮箱
     * @param obj 
     */
    public isEmail(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.Email, obj);
    }

    /**
     * 判断是否为邮编
     * @param obj 
     */
    public isZIP(obj) {
        if (this.isNull(obj))
            return false;
        return this.validator(REGEXP.邮编, obj);
    }

    /**
     * 校验是否为里程，里程的具体一种格式
     * @param val 
     */
    public isMileageTagNoHasXJ(val) {
        if (this.isNull(val)) return false;
        return this.validator(REGEXP.里程桩号, val)
    }

    /**
     * 校验里程桩号
     * @param val 
     */
    public isMileageTag(val) {
        if (this.isNull(val)) return false;
        return this.isMileageTagNoHasXJ(val);
    }

    /**
     * 校验手机号码
     * @param val 
     */
    public isPhone(val) {
        if(this.isNull(val)) return false;
        return this.validator(REGEXP.手机号码, val)
    }

    //#endregion

    //#region 生成ElForm所需的校验规则

    /**
     * 校验规则
     * @param trigger 
     * @param validatorMethod 
     * @param errorMsg 
     */
    public elRule(trigger: FormTrigger = FormTrigger.blur, validatorMethod: (obj) => boolean, errorMsg: string) {
        const that = this;
        return {
            trigger: trigger, validator: (rule, value, callback) => {
                if (that.isNull(value)) callback();
                if (!validatorMethod.call(that, value)) {
                    callback(new Error(errorMsg));
                } else {
                    callback();
                }
            }
        }
    }

    /**
     * 英文字母规则
     * @param trigger 触发类型
     */
    public elRuleLetter(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isLetter, '只能输入英文字母');
    }

    /**
     * 邮箱规则
     * @param trigger 
     */
    public elRuleEmail(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isEmail, '邮箱格式不正确');
    }

    /**
     * 邮编规则
     * @param trigger 
     */
    public elRuleZIP(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isZIP, '邮编格式不正确');
    }

    /**
     * 汉字规则
     * @param trigger 
     */
    public elRuleChinese(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isChinese, '只能输入汉字');
    }

    /**
     * 字母和数字规则
     * @param trigger 
     */
    public elRuleLetterAndNumber(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isLetterAndNumber, '只能输入字母和数字');
    }

    /**
     * 双精度规则
     * @param trigger 
     */
    public elRuleDouble(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isDouble, '只能为小数');
    }

    /**
     * 整数规则
     * @param trigger 
     */
    public elRuleInt(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isInt, '只能为整数');
    }

    /**
     * 日期规则 YYYY-MM-DD格式的类型  
     * @param trigger 
     */
    public elRuleDate(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isDate, '日期格式不正确，应如：YYYY-MM-DD');
    }

    /**
     * 日期规则 YYYY-MM-DD hh:mm:ss格式的类型
     * @param trigger 
     */
    public elRuleDateTime(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isDateTime, '日期格式不正确，应如：YYYY-MM-DD hh:mm:ss');
    }

    /**
     * 时间格式规则
     * @param trigger 
     */
    public elRuleTime(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isTime, '时间格式不正确，应如：hh:mm:ss');
    }

    /**
     * 桩号规则
     * @param trigger 
     */
    public elRuleMileageTag(trigger: FormTrigger = FormTrigger.blur) {
        return this.elRule(trigger, this.isMileageTag, '桩号格式输入错误，应如：(0-3位字母)K88+888.88 ');
    }

    /**
     * 必填规则
     * @param message 提示信息
     * @param trigger 触发校验类型
     */
    public elRuleRequired(message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { required: true, message: message, trigger: trigger };
    }

    /**
     * 最小长度规则
     * @param min 最小长度
     * @param message 提示信息
     * @param trigger 触发校验类型
     */
    public elRuleMin(min: number, message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { min: min, message: message, trigger: trigger };
    }

    /**
     * 最大长度规则
     * @param max 最大长度
     * @param message 提示信息
     * @param trigger 校验触发类型
     */
    public elRuleMax(max: number, message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { max: max, message: message, trigger: trigger };
    }

    /**
     * 最小最大长度规则
     * @param min 最小长度
     * @param max 最大长度
     * @param message 提示信息
     * @param trigger 触发校验类型
     */
    public elRuleMinMax(min: number, max: number, message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { min: min, max: max, message: message, trigger: trigger };
    }

    /**
     * 根据类型获取校验规则
     * @param elRuleType 校验规则类型
     * @param message 提示信息
     * @param trigger 触发校验类型
     */
    public elRuleType(elRuleType: ElRuleType, message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { type: elRuleType, message: message, trigger: trigger };
    }

    /**
     * 根据传入的正则表达式进行校验
     * @param pattern 正则表达式
     * @param message 提示信息
     * @param trigger 触发校验类型
     */
    public elRulePattern(pattern, message: string, trigger: FormTrigger = FormTrigger.blur) {
        return { pattern: pattern, message: message, trigger: trigger };
    }



    //#endregion

}


/**
 * 详细的校验信息参见：https://github.com/yiminghe/async-validator
 * 可进行更为复杂的校验
 */
export default new ValidatorHelper();